import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WelcomeStep = ({ onNext }) => {
  return (
    <div className="text-center space-y-8 py-8">
      <div className="inline-flex items-center justify-center w-24 h-24 bg-primary/10 rounded-2xl">
        <img src="/assets/images/MyBodyToday_logo_design2-removebg-preview1-1770673381636.png" alt="MyBodyToday Logo" className="w-20 h-20 object-contain" />
      </div>

      <div className="space-y-4">
        <h1 className="text-3xl md:text-4xl font-bold text-foreground">
          Welcome to MyBodyToday
        </h1>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Your trusted companion for daily symptom tracking and health management
        </p>
      </div>

      {/* Value Propositions */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
        <div className="bg-card border border-border rounded-lg p-6 text-center">
          <div className="w-12 h-12 bg-teal-500/10 rounded-lg flex items-center justify-center mx-auto mb-3">
            <Icon name="Activity" size={24} className="text-teal-600" />
          </div>
          <h3 className="font-semibold text-foreground mb-2">Track Daily</h3>
          <p className="text-sm text-muted-foreground">
            Monitor your symptoms and health patterns every day
          </p>
        </div>

        <div className="bg-card border border-border rounded-lg p-6 text-center">
          <div className="w-12 h-12 bg-blue-500/10 rounded-lg flex items-center justify-center mx-auto mb-3">
            <Icon name="TrendingUp" size={24} className="text-blue-600" />
          </div>
          <h3 className="font-semibold text-foreground mb-2">Understand Trends</h3>
          <p className="text-sm text-muted-foreground">
            Visualize your health data with insightful analytics
          </p>
        </div>

        <div className="bg-card border border-border rounded-lg p-6 text-center">
          <div className="w-12 h-12 bg-purple-500/10 rounded-lg flex items-center justify-center mx-auto mb-3">
            <Icon name="FileText" size={24} className="text-purple-600" />
          </div>
          <h3 className="font-semibold text-foreground mb-2">Share Reports</h3>
          <p className="text-sm text-muted-foreground">
            Generate comprehensive reports for your healthcare providers
          </p>
        </div>
      </div>

      {/* Security Badge */}
      <div className="bg-primary/5 border border-primary/20 rounded-lg p-6 max-w-2xl mx-auto">
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <div className="flex items-center gap-2">
            <Icon name="Shield" size={20} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Privacy-Focused</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Lock" size={20} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Encrypted Health Data</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Eye" size={20} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Secure Messaging</span>
          </div>
        </div>
      </div>

      <Button
        size="lg"
        onClick={onNext}
        iconName="ArrowRight"
        iconPosition="right"
        className="min-w-[200px]"
      >
        Get Started
      </Button>

      <p className="text-xs text-muted-foreground">
        This setup will take about 2-3 minutes
      </p>
    </div>
  );
};

export default WelcomeStep;